import type { ReactNode } from 'react';
import { Card, Icon } from '@mypoz/ui';

export interface LockedStepProps {
  /** Why this step cannot be changed, in the customer's own terms. */
  note: string;
  children: ReactNode;
}

/**
 * A step that can be read but not changed, with the reason above it.
 *
 * Deliberately a read-only rendering rather than the real form with every control disabled. A
 * greyed-out checkbox invites clicking and then says nothing when the click does nothing; a plain
 * list says "this is what it is" and the note says why. It also keeps `PackageRow` and
 * `ChannelPicker` free of a disabled mode they would otherwise carry for one caller.
 *
 * The note leads rather than following, because someone who has just clicked Edit is looking for
 * the control, and the answer to "where is it?" has to arrive before the empty space does.
 */
export function LockedStep({ note, children }: LockedStepProps) {
  return (
    <div className="grid gap-4">
      <p className="flex items-start gap-2.5 border-l-2 border-brand pl-3 text-sm text-ink">
        <Icon name="lock" size={18} className="mt-0.5 shrink-0 text-muted" />
        <span>{note}</span>
      </p>

      <Card className="grid gap-1.5 text-sm">{children}</Card>
    </div>
  );
}
